<template>
  <b-modal ref="deleteModal" title="Benutzer löschen">
    <p class="text-center">
      ACHTUNG! Hiermit wird der Benutzer unwideruflich gelöscht!
    </p>
    <template slot="modal-footer">
      <b-btn class="mt-3" variant="danger" block @click="confirm">Bestätigen</b-btn>
      <b-btn class="mt-3" variant="secondary" block @click="hide">Abbrechen</b-btn>
    </template>
  </b-modal>
</template>
<script>
export default {
  name: 'DeleteModal',
  methods: {
    show: function () {
      this.$refs.deleteModal.show()
    },

    hide () {
      this.$refs.deleteModal.hide()
    },

    confirm () {
      this.$emit('confirm')
      this.hide()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/user/DeleteModal.vue